import { isNilOrEmpty } from '../../../helpers/utils';

export function getResultsLength(data) {
  if (isNilOrEmpty(data) || isNilOrEmpty(data.histograms)) {
    return 0;
  }
  let count = 0;
  data.histograms.forEach((item) => {
    if (item.dataType !== 'EMPTY_FROM_API') {
      count += 1;
    }
  });
  return count;
}
